var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('form-group',{attrs:{"iptData":_vm.iptData}},[_vm._v("\n  未定义类型 "+_vm._s(_vm.iptData.widget)+"\n")])}
var staticRenderFns = []

export { render, staticRenderFns }